import { ChangeDetectionStrategy, Component, HostListener, model, OnDestroy } from '@angular/core';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { AppNavigationComponent } from '@layout/app-navigation/app-navigation.component';
import { TranslateModule } from '@ngx-translate/core';
import { TrapFocusDirective } from '@shared/directives/trap-focus.directive';
import { AppRoutesEnum } from '@shared/types';
import { DrawerComponent } from '@ui-kit/miscs';
import { ButtonDirective } from 'primeng/button';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    standalone: true,
    imports: [
        TranslateModule,
        ButtonDirective,
        DrawerComponent,
        AppNavigationComponent,
        TrapFocusDirective,
        RouterLink,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuComponent implements OnDestroy {
    isSidebarVisible = model<boolean>(false);
    routerSubscription!: Subscription;

    readonly appRoutes = AppRoutesEnum;

    constructor(private router: Router) {}

    @HostListener('window:resize', ['$event.target.innerWidth'])
    onScreenResize(width: number) {
        if (width <= 990) {
            this.routerSubscription = this.router.events.subscribe((event: any) => {
                if (event instanceof NavigationStart && this.isSidebarVisible()) {
                    this.isSidebarVisible.set(false);
                }
            });
        }

        if (width > 991) {
            this.isSidebarVisible.set(false);
            this.routerSubscription?.unsubscribe();
        }
    }

    ngOnDestroy(): void {
        this.routerSubscription.unsubscribe();
    }
}
